import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=4edc6a98&scoped=true&"
import script from "./baseDialog.vue?vue&type=script&lang=js&"
export * from "./baseDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=4edc6a98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc6a98",
  null
  
)

export default component.exports